import type { SnackBarPropItemAction } from '@consta/uikit/SnackBar'
import { SnackBar } from '@consta/uikit/SnackBar'
// eslint-disable-next-line import/no-internal-modules
import {
  getStore,
  removeNotification,
  selectNotifications,
  useAppDispatch,
  useAppSelector,
} from '@notifications/core/store'
import type { GeomateNotification, NotificationId } from 'common/types'
import type { FC, JSX } from 'react'
import { Provider } from 'react-redux'

import { getItemMessage, useActions } from './helpers'
import css from './Notifications.css'

export const NotificationsComponent: FC = () => {
  const dispatch = useAppDispatch()

  const notifications = useAppSelector(selectNotifications)

  const closeNotification = (id: NotificationId) => {
    const notification = notifications.find(notification => notification.id === id)

    notification?.notificationCloseCb?.()

    dispatch(removeNotification(id))
  }

  const undoDelete = (id: NotificationId) => {
    dispatch(removeNotification(id))
  }

  const getHandler = useActions(undoDelete)

  const getActions = (item: GeomateNotification): SnackBarPropItemAction[] | undefined => {
    return item.actions?.map(button => ({
      label: button.label,
      onClick: () => {
        const onButtonClick = getHandler(button.onClick, item.id)
        onButtonClick()
      },
    }))
  }

  return (
    <SnackBar
      className={css.container}
      items={notifications}
      getItemKey={item => item.id}
      getItemAutoClose={item => item.autoClose}
      getItemActions={getActions}
      getItemMessage={getItemMessage}
      onItemClose={({ id }) => {
        closeNotification(id)
      }}
    />
  )
}

export const Notifications = (props: JSX.IntrinsicAttributes) => {
  return (
    <Provider store={getStore()}>
      <NotificationsComponent {...props} />
    </Provider>
  )
}
